import Head from 'next/head'
import { GameZoneHistory } from '@/components/templates/GameZone/History'
import { useTranslation } from 'next-i18next/pages'

const GameZoneHistoryPage = () => {
  const { t } = useTranslation('common')
  return (
    <>
      <Head>
        <title>{t('game-zone.history-title')}</title>
        <meta name="description" content={t('game-zone.history-meta-description')} />
      </Head>
      <GameZoneHistory />
    </>
  )
}

export default GameZoneHistoryPage
